import { Utilities } from "../../../utils/utilities";
import { CompanyData } from "../Company/CompanyData";
import { CreatedByData } from "../General/CreatedByData";
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { RelativeDataType } from "../General/RelativeData";

export class TrashcanItemData extends FirebaseData {
  name: string = "";
  companies: CompanyData[] = [];
  deletedBy?: CreatedByData;
  permanentDeletion?: Date;
  type?: RelativeDataType;

  setup(data: any) {
    if (typeof data.type === "number") {
      this.type = data.type;
    }

    if (typeof data.name === "string") {
      this.name = data.name;
    }

    if (data.permanentDeletion) {
      this.permanentDeletion = Utilities.getDateFromTimestamp(data.permanentDeletion);
    }

    if (Array.isArray(data.companyIDs)) {
      this.companies = [];
      for (const companyID of data.companyIDs) {
        if (typeof companyID === "string") this.companies.push(LocalData.companies.addData(companyID));
      }
    }

    if (this.isValidObject(data.deletedBy)) {
      this.deletedBy = new CreatedByData(data.deletedBy);
    }

    super.setup(data);
  }
}

